
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/students",
      function () {
        return require("private-next-pages/account/students/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/students"])
      });
    }
  